import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 3rem clamp(1rem, 4vw, 3.5rem) 4rem;

  @media (max-width: 768px) {
    padding: 1rem 0.85rem 2.75rem;
  }
`;

export const BackButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.blue11};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0 0 1.2rem;
  padding: 0;
  transition: color 0.2s ease, transform 0.2s ease;

  i {
    font-size: 1.1rem;
    line-height: 1;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.blue9};
    transform: translateX(-2px);
  }

  @media (max-width: 680px) {
    font-size: 0.82rem;
    margin-bottom: 0.85rem;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.4rem;

  @media (max-width: 560px) {
    align-items: center;
    margin-bottom: 1rem;
  }
`;

export const HeaderCopy = styled.div`
  display: grid;
  gap: 0.25rem;
`;

export const Eyebrow = styled.div`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.blue9};
  font-size: clamp(1.55rem, 3vw, 2rem);
  line-height: 1.1;
  margin: 0;

  @media (max-width: 680px) {
    font-size: 1.45rem;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.9rem;
  line-height: 1.4;
  max-width: 720px;
  margin: 0;
`;

export const ProductCount = styled.div`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: clamp(0.95rem, 2vw, 1.25rem);
  line-height: 1.2;
  white-space: nowrap;

  @media (max-width: 680px) {
    background: ${({ theme }) => theme.colors.blue2};
    border: 1px solid ${({ theme }) => theme.colors.blue3};
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 800;
    padding: 0.45rem 0.65rem;
  }
`;

export const Controls = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(180px, 220px);
  gap: 0.8rem;
  align-items: end;
  margin-bottom: 2rem;

  @media (max-width: 680px) {
    grid-template-columns: minmax(0, 1fr) minmax(112px, 36%);
    gap: 0.65rem;
    margin-bottom: 1.35rem;
  }

  @media (max-width: 380px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchGroup = styled.div`
  display: grid;
  gap: 0.4rem;
`;

export const FilterGroup = styled.div`
  position: relative;
  display: grid;
  gap: 0.4rem;
`;

export const SearchLabel = styled.label`
  color: ${({ theme }) => theme.colors.blue10};
  font-size: 0.85rem;
  font-weight: 600;

  @media (max-width: 680px) {
    font-size: 0.72rem;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  background: rgba(250, 252, 255, 0.04);
  border: 1px solid ${({ theme }) => theme.colors.blue3};
  border-radius: 12px;
  color: ${({ theme }) => theme.colors.blue9};
  font-family: inherit;
  font-size: 0.95rem;
  padding: 0.85rem 1rem;

  @media (max-width: 680px) {
    min-height: 44px;
    border-radius: 8px;
    font-size: 0.86rem;
    padding: 0.68rem 0.75rem;
  }
`;

export const FilterButton = styled.button`
  width: 100%;
  background:
    linear-gradient(135deg, ${({ theme }) => theme.colors.blue2}, ${({ theme }) => theme.colors.blue3});
  border: 1px solid ${({ theme }) => theme.colors.blue3};
  border-radius: 12px;
  color: ${({ theme }) => theme.colors.blue9};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  font-family: inherit;
  font-size: 0.92rem;
  font-weight: 700;
  min-height: 48px;
  padding: 0.85rem 0.85rem 0.85rem 1rem;
  text-align: left;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i {
    color: ${({ theme }) => theme.colors.blue10};
    flex: 0 0 auto;
    font-size: 1.25rem;
    line-height: 1;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.blue8};
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.blue8};
    box-shadow: 0 0 0 3px rgba(91, 141, 239, 0.18);
    outline: none;
  }

  @media (max-width: 680px) {
    min-height: 44px;
    border-radius: 8px;
    font-size: 0.82rem;
    padding: 0.68rem 0.55rem 0.68rem 0.75rem;

    i {
      font-size: 1.05rem;
    }
  }
`;

export const FilterMenu = styled.div`
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  z-index: 20;
  width: min(260px, 100vw - 2rem);
  max-height: 18rem;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.blue2};
  border: 1px solid ${({ theme }) => theme.colors.blue3};
  border-radius: 14px;
  box-shadow: 0 22px 54px rgba(0, 0, 0, 0.36);
  padding: 0.35rem;

  @media (max-width: 680px) {
    border-radius: 10px;
    max-height: 16rem;
    width: min(230px, 100vw - 1.7rem);
  }

  @media (max-width: 380px) {
    left: 0;
    right: auto;
    width: 100%;
  }
`;

export const FilterOption = styled.button<{ $active?: boolean }>`
  width: 100%;
  background: ${({ $active, theme }) => ($active ? theme.colors.blue3 : 'transparent')};
  border: 0;
  border-radius: 10px;
  color: ${({ $active, theme }) => ($active ? theme.colors.blue9 : theme.colors.blue11)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 0.7rem 0.75rem;
  text-align: left;
  transition: background 0.16s ease, color 0.16s ease;

  span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  i {
    color: ${({ theme }) => theme.colors.blue10};
    flex: 0 0 auto;
    font-size: 1rem;
    line-height: 1;
  }

  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.colors.blue3};
    color: ${({ theme }) => theme.colors.blue9};
    outline: none;
  }

  @media (max-width: 680px) {
    border-radius: 8px;
    font-size: 0.78rem;
    padding: 0.62rem 0.6rem;
  }
`;

export const ToolGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: clamp(1.4rem, 3vw, 2.4rem);
  row-gap: 2.4rem;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 820px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.6rem 1rem;
  }

  @media (max-width: 680px) {
    gap: 1.25rem 0.7rem;
  }
`;

export const ProductBlock = styled.div`
  margin: 0 0 2.9rem;

  @media (max-width: 680px) {
    margin-bottom: 2rem;
  }
`;

export const ShelvesWrap = styled.div`
  display: grid;
  gap: 2.1rem;
  margin: 0 0 2.7rem;
`;

export const ShelfInterlude = styled.div`
  margin: 0 0 2.9rem;

  @media (max-width: 680px) {
    margin-bottom: 2rem;
  }
`;

export const ShelfSection = styled.section`
  min-width: 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0 0 1rem;

  @media (max-width: 680px) {
    margin-bottom: 0.75rem;
  }
`;

export const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.blue9};
  font-size: clamp(1.05rem, 2vw, 1.3rem);
  line-height: 1.1;
  margin: 0;

  @media (max-width: 680px) {
    font-size: 1rem;
  }
`;

export const SectionCount = styled.div`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.9rem;
  font-weight: 700;
`;

export const ShelfTrack = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(210px, 240px);
  gap: 1rem;
  margin-inline: calc(clamp(1rem, 4vw, 3.5rem) * -1);
  overflow-x: auto;
  overscroll-behavior-x: contain;
  padding: 0 clamp(1rem, 4vw, 3.5rem) 0.4rem;
  scroll-padding-inline: clamp(1rem, 4vw, 3.5rem);
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;

  @media (max-width: 768px) {
    grid-auto-columns: minmax(138px, 42vw);
    gap: 0.75rem;
    margin-inline: -0.85rem;
    padding-inline: 0.85rem;
    scroll-padding-inline: 0.85rem;
  }

  @media (max-width: 380px) {
    grid-auto-columns: minmax(132px, 48vw);
  }
`;

export const ShelfCard = styled.article`
  min-width: 0;
  color: inherit;
  display: grid;
  gap: 0.75rem;
  scroll-snap-align: start;
  text-decoration: none;
  transition: transform 0.2s ease;

  &[href]:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 680px) {
    gap: 0.5rem;
  }
`;

export const ShelfImage = styled.div<{ $image: string }>`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 48px;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(250, 252, 255, 0.06), rgba(250, 252, 255, 0.02));
  background-color: ${({ theme }) => theme.colors.blue2};
  position: relative;
  isolation: isolate;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.blue3};
  transition: box-shadow 0.2s ease, filter 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.blue3};
    pointer-events: none;
    z-index: 2;
  }

  ${ShelfCard}[href]:hover & {
    box-shadow:
      inset 0 0 0 1px ${({ theme }) => theme.colors.blue5},
      0 18px 36px rgba(0, 0, 0, 0.18);
    filter: brightness(1.05);
  }
`;

export const ShelfImageAsset = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
  object-position: center;
`;

export const ShelfContent = styled.div`
  display: grid;
  gap: 0.2rem;
  padding: 0 0.1rem;
`;

export const ShelfTitle = styled.h3`
  color: ${({ theme }) => theme.colors.blue9};
  display: -webkit-box;
  font-size: 0.98rem;
  line-height: 1.15;
  margin: 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media (max-width: 680px) {
    font-size: 0.78rem;
    line-height: 1.1;
  }
`;

export const ShelfPlatform = styled.p`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 0;

  @media (max-width: 680px) {
    font-size: 0.66rem;
  }
`;

export const ToolCard = styled.a`
  min-width: 0;
  color: inherit;
  display: grid;
  gap: 0.95rem;
  text-decoration: none;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 680px) {
    gap: 0.55rem;
  }
`;

export const ToolMedia = styled.div<{ $image?: string }>`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 14px;
  overflow: hidden;
  background:
    linear-gradient(135deg, rgba(250, 252, 255, 0.06), rgba(250, 252, 255, 0.02)),
    ${({ $image, theme }) => ($image ? `url(${$image})` : theme.colors.blue3)};
  background-size: ${({ $image }) => ($image ? 'cover' : 'auto')};
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.blue9};
  position: relative;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.blue3};
  transition: box-shadow 0.2s ease, filter 0.2s ease;

  ${ToolCard}:hover & {
    box-shadow:
      inset 0 0 0 1px ${({ theme }) => theme.colors.blue5},
      0 18px 36px rgba(0, 0, 0, 0.18);
    filter: brightness(1.05);
  }

  i {
    font-size: 42px;
  }

  @media (max-width: 680px) {
    border-radius: 8px;
  }
`;

export const PlatformBadge = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2.15rem;
  height: 2.15rem;
  border-radius: 0.55rem;
  background: rgba(15, 17, 19, 0.9);
  border: 1px solid rgba(250, 252, 255, 0.08);
  color: ${({ theme }) => theme.colors.blue11};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  i {
    font-size: 1.15rem;
  }

  @media (max-width: 680px) {
    top: 0.5rem;
    right: 0.5rem;
    width: 1.65rem;
    height: 1.65rem;
    border-radius: 0.45rem;

    i {
      font-size: 0.9rem;
    }
  }
`;

export const ToolContent = styled.div`
  min-width: 0;
  display: grid;
  gap: 0.22rem;
  padding: 0 0.15rem;

  @media (max-width: 680px) {
    gap: 0.15rem;
    padding: 0;
  }
`;

export const ToolMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;

  span {
    color: ${({ theme }) => theme.colors.blue11};
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
  }
`;

export const ToolTitle = styled.h2`
  color: ${({ theme }) => theme.colors.blue9};
  font-size: clamp(1.05rem, 2vw, 1.25rem);
  line-height: 1.12;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 680px) {
    font-size: 0.92rem;
    line-height: 1.08;
  }
`;

export const ToolPlatform = styled.p`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;

  @media (max-width: 680px) {
    font-size: 0.68rem;
  }
`;

export const ToolPrice = styled.div`
  color: ${({ theme }) => theme.colors.blue9};
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.25;
  margin-top: 0.25rem;

  @media (max-width: 680px) {
    font-size: 0.78rem;
    margin-top: 0.1rem;
  }
`;

export const EmptyState = styled.div`
  background: ${({ theme }) => theme.colors.blue2};
  border: 1px solid ${({ theme }) => theme.colors.blue3};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.blue11};
  padding: 2rem;
  text-align: center;
`;

export const UpdatesWrap = styled.div`
  width: 100%;
  margin: 3rem 0 0;

  @media (max-width: 680px) {
    margin-top: 2.25rem;
  }
`;
